/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React from 'react';

import { Stack, Box, Button, Tooltip, Link } from '@mui/material';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import theme from '../theme';
import { SearchAddress } from '../containers/SearchAddress';
import Directions from '../containers/Directions';
import { FontAwesomeSvgIcon } from 'handimap-react-lib/components/FontAwesomeSvgIcon';
import { Options } from 'handimap-react-lib/containers/Options';
import { PathsCards } from 'handimap-react-lib/containers/PathCardsDetails';
import { Roadmap } from 'handimap-react-lib/containers/RoadMapSteps';
import { setOpenSideBar } from 'handimap-react-lib/store/actions/sideBarActions';
import { LanguageSelector } from '../components/LanguageSelector';
import { ShareItineraryButton } from 'handimap-react-lib/components/ShareItineraryButton';
import { config } from 'handimap-react-lib/config.js';
import { SelectedDetails } from './SelectedDetails';
import { typeAccessibility } from '../enum/typeAccessibility';

export const SideBarContent = ({
  status,
  allResults,
  isMobile,
  convertProfiltForApi,
}) => {
  const contentType = useSelector((state) => state.sideBar.contentType);
  const selectedFeature = useSelector((state) => state.selectedFeature);
  const { selected, feature, backSection } = selectedFeature;

  const selectedPath = useSelector((state) => state.directions.selectedPath);

  const dispatch = useDispatch();

  const { t, i18n } = useTranslation();

  const { palette } = theme;

  const styleSwitch = {
    primary: palette.primary.main,
    primaryContrast: palette.primary.contrastText,
    secondary: palette.secondary.main,
    secondaryContrast: palette.secondary.contrastText,
  };

  const styles = {
    stackSide: {
      display: 'flex',
      width: '100%',
      minHeight: 'calc(100% - 1em)',
      backgroundColor: palette.primary.main,
    },
  };

  return (
    <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
      <Stack sx={styles.stackSide} direction='column' spacing={3.5}>
        {contentType === 'direction' && (
          <>
            {isMobile ? (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100vw',
                  backgroundColor: palette.primary.main,
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  position: 'sticky',
                  top: 0,
                  paddingY: '1em',
                  zIndex: 100,
                }}
              >
                <Box sx={{ marginLeft: '1em' }}>
                  <LanguageSelector />
                </Box>
                {/* Semantic icon https://mui.com/material-ui/icons/#semantic-icons
                  <button aria-label="My label"> 
                    <svg focusable="false" aria-hidden="true" >
                        <!-- svg content -->
                    </svg>
                </button>  */}
                <Box sx={{ marginRight: '1em' }}>
                  <Button
                    variant='contained'
                    color='contrastprimary'
                    aria-label={t('side-bar.aria-close-label')}
                    onClick={() => dispatch(setOpenSideBar(false))}
                  >
                    <FontAwesomeSvgIcon icon={faTimes} />
                  </Button>
                </Box>
              </Box>
            ) : (
              <></>
            )}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'top',
                paddingY: '1em',
                paddingX: '2em',
                backgroundColor: 'white',
                justifyContent: 'center',
              }}
            >
              <Tooltip
                title={
                  <p
                    style={{
                      fontSize: '1em',
                    }}
                  >
                    {t('side-bar.aria-back-home')}
                  </p>
                }
                placement={isMobile ? 'top-end' : 'bottom-start'}
                arrow
              >
                <Link
                  sx={{
                    display: 'inline-block',
                    position: 'relative',
                    zIndex: 1,
                  }}
                  href={`${config.url.HOME_PAGE_URL}?lng=${i18n.language}`}
                >
                  <span style={{ display: 'inline-block' }}>
                    <object
                      style={{
                        position: 'relative',
                        zIndex: -1,
                      }}
                      width='130em'
                      tabIndex='-1'
                      type='image/svg+xml'
                      role='img'
                      aria-label={t('side-bar.aria-back-home')}
                      data={
                        config.url.PUBLIC_URL + '/logo-herault-mobility.svg'
                      }
                    ></object>
                  </span>
                </Link>
              </Tooltip>
            </Box>
            <SearchAddress />
            <Options isMobile={isMobile} showCondition={false} />
            <Directions
              isMobile={isMobile}
              multimodalActivated={false}
              styles={styleSwitch}
            />
            <ShareItineraryButton
              convertProfiltForApi={convertProfiltForApi}
              status={status}
              allResults={allResults}
              multimodalActivated={false}
            />
            <PathsCards
              isMobile={isMobile}
              status={status}
              allResults={allResults}
              selectedPath={selectedPath}
              multimodalActivated={false}
            />
            {/* <ListSuggestions isMobile={isMobile} /> */}
          </>
        )}
        {contentType === 'stepsDetails' && (
          <Roadmap
            typeAcc={typeAccessibility}
            status={status}
            allResults={allResults}
            selectedPath={selectedPath}
            isMobile={isMobile}
          />
        )}
        {selected &&
          contentType !== 'stepsDetails' &&
          contentType !== 'direction' && (
            <SelectedDetails
              typeAcc={typeAccessibility}
              isMobile={isMobile}
              status={status}
              contentType={contentType}
              feature={feature}
              backSection={backSection}
            />
          )}
      </Stack>
    </Box>
  );
};
